import HttpClient from 'services/api';
import { ENDPOINTS } from 'services/api/endpoints';

// Retorna todos os Termos de Uso disponíveis
export const getEula = () => HttpClient.get(ENDPOINTS.EULA);

// Retorna o Termo de Uso pendente
export const getPendingEula = () => HttpClient.get(ENDPOINTS.EULA_PENDING);

// Aceita os Termos de Uso
export const acceptEula = (id) => HttpClient.post(ENDPOINTS.EULA_ACCEPT.replace(':id', id), {});
